import React from 'react';
import { Instagram, Twitter, Facebook, Mail } from 'lucide-react';

// Update these to your real handles/email anytime.
const SOCIAL = {
  instagram: 'https://instagram.com/trucrunch.in',
  twitter:   'https://twitter.com/trucrunch',
  facebook:  'https://facebook.com/trucrunch',
  email:     'mailto:care@trucrunch.in',
};

const socialLinks = [
  { Icon: Instagram, href: SOCIAL.instagram, label: 'Instagram' },
  { Icon: Twitter,   href: SOCIAL.twitter,   label: 'Twitter' },
  { Icon: Facebook,  href: SOCIAL.facebook,  label: 'Facebook' },
  { Icon: Mail,      href: SOCIAL.email,     label: 'Email' },
];

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-[#FFF4E6] px-5 md:px-8 py-12">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="inline-block bg-[#FFF4E6] rounded-2xl px-4 py-3 crunch-shadow-sm">
            <img
              src="https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/0ug68r65_download.png"
              alt="TruCrunch"
              className="h-10 md:h-12 w-auto"
            />
          </div>
          <p className="font-brico mt-4 opacity-70 max-w-sm">Snacks that don't play boring. Made in India with real millets, big flavour and serious crunch.</p>

          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-3 bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF] px-4 py-2.5 rounded-full text-white font-brico font-bold text-sm hover:-translate-y-0.5 transition-transform"
          >
            <Instagram size={18} /> Follow @trucrunch.in
          </a>

          <div className="flex gap-3 mt-5">
            {socialLinks.map(({ Icon, href, label }, i) => (
              <a
                key={i}
                href={href}
                target={href.startsWith('mailto:') ? '_self' : '_blank'}
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#E63946] hover:border-[#E63946] transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="font-display uppercase text-lg mb-3">Snacks</div>
          <ul className="space-y-2 font-brico opacity-70">
            <li><a href="/shop" className="hover:opacity-100 hover:text-white">Spicy</a></li>
            <li><a href="/shop" className="hover:opacity-100 hover:text-white">Cheesy</a></li>
            <li><a href="/shop" className="hover:opacity-100 hover:text-white">Sweet</a></li>
            <li><a href="/shop" className="hover:opacity-100 hover:text-white">Protein</a></li>
          </ul>
        </div>

        <div>
          <div className="font-display uppercase text-lg mb-3">Company</div>
          <ul className="space-y-2 font-brico opacity-70">
            <li><a href="/track" className="hover:opacity-100 hover:text-white">Track Order</a></li>
            <li><a href="/#story" className="hover:opacity-100 hover:text-white">Our Story</a></li>
            <li><a href="/#partner" className="hover:opacity-100 hover:text-white">Partner</a></li>
            <li>
              <a href="/#contact" className="hover:opacity-100 hover:text-white inline-flex items-center gap-1.5">
                <Mail size={12} /> Contact us
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-3 font-brico text-sm opacity-60">
        <div>© {new Date().getFullYear()} TruCrunch. Made in India.</div>
        <div>Privacy • Terms • Shipping</div>
      </div>
    </footer>
  );
};

export default Footer;
